import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase/config';

/**
 * Verify an invite token via Cloud Function.
 * Returns { email, valid } or throws (invalid/expired).
 * The token is a secret bearer credential; the server looks it up by its hash.
 */
export async function verifyInviteToken(token) {
  const callable = httpsCallable(functions, 'verifyInviteToken');
  const result = await callable({ token });
  const data = result.data || {};
  if (!data.valid || !data.email) {
    throw new Error('Invite link invalid or already used');
  }
  return { email: data.email, valid: true };
}

/**
 * Accept an invite: the server creates the Firebase Auth user, activates the
 * auditor record, and deletes the invite token. The client is never signed in
 * during this flow — the user logs in afterwards with their new password
 * (encryption keys are generated on first login).
 */
export async function acceptInvite(token, password) {
  const callable = httpsCallable(functions, 'acceptInvite');
  const result = await callable({ token, password });
  return result.data;
}
